import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons/index.tsx';
import { iconInfoCircle } from '@sorare/core/src/atoms/icons/system/iconInfoCircle.ts';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { LabelS } from '@sorare/core/src/atoms/typography';

const Root = styled(LabelS)`
  align-self: center;
`;

export const ScoresLockWarning = () => (
  <Root color="var(--c-nd-500)">
    <Horizontal gap={0.5}>
      <FontAwesomeIcon icon={iconInfoCircle} />
      <FormattedMessage defaultMessage="Scores lock 5 mins after each final whistle. Stats updated after that won't count." />
    </Horizontal>
  </Root>
);
